import { Ikon } from '../Ikon.tsx';
import { H } from './primitiver.tsx';
import { tekst } from './tekster.ts';

/**
 * 2b — første valg. To flater, ikon og tekst. DD-02: ALDRI et tredje valg, og
 * aldri spørsmål om kategori eller alvorlighet.
 *
 * Presisert 2026-09-14 (C4): undertekstene sier hva valget BETYR for
 * innsenderen — «Feilsporet» og «Ønskesporet» er repoets ord (DD-50), og
 * skjermleseren leste dem opp som en del av knappen. Setningen «Vi spør aldri om
 * kategori eller alvorlighet» er et løfte om noe systemet ikke gjør, og hører
 * ikke i nivå 1 (`ux-flow-architect`).
 */
export function Valg({ onVelg }: { onVelg: (spor: 'feil' | 'onske') => void }) {
  const flate = (spor: 'feil' | 'onske', ikon: string, label: string, under: string) => (
    <button type="button" className="innspel-flate" data-testid={`spor-${spor}`} aria-label={`${label}. ${under}`} onClick={() => onVelg(spor)}>
      <span className="innspel-flate-ikon">
        <Ikon navn={ikon} />
      </span>
      <span className="innspel-flate-tittel">{label}</span>
      <span className="innspel-flate-under">{under}</span>
    </button>
  );

  return (
    <div className="innspel-stabel">
      <H>{tekst.valgTittel}</H>
      <div className="innspel-rad" data-gap="md">
        {/* Fylt ikon i merkefargen på en rund tonet flate (DD-63) — se .innspel-flate-ikon. */}
        {flate('feil', 'bug', tekst.sporFeil, tekst.sporFeilUnder)}
        {flate('onske', 'bulb', tekst.sporOnske, tekst.sporOnskeUnder)}
      </div>
    </div>
  );
}
